import { formatarData } from 'src/app/core/utils/utilities';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { ITabelaEstacionamentoTpg } from './listagem-estacionamento-tpg-model';
import { PaleteService } from 'src/app/services/PaleteService/palete.service';
import { IGetMovimentacoesPaletesPaginatedByFiltersParams } from 'src/app/services/PaleteService/palete.model';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';

@Component({
  selector: 'app-listagem-estacionamento-tpg',
  templateUrl: './listagem-estacionamento-tpg.component.html',
  styleUrls: ['./listagem-estacionamento-tpg.component.scss']
})
export class ListagemEstacionamentoTpgComponent {
  form = this.initForm();
  numeroPagina: number = 0;
  maxPages: number = 1;
  isLoading: boolean = false;
  expandirCardsMobile: boolean = true;

  tableData: ITabelaEstacionamentoTpg[] | Array<any> = [];

  tableColumns = [
    { header: 'Código do Serviço', key: 'PK_MOVM_PLTE', type: 'text' },
    {
      header: 'Relação Entrada/Saída Estacionamento',
      key: 'FK_MOVM_PLTE',
      type: 'text'
    },
    { header: 'Código do Agendamento', key: 'FK_AGND', type: 'text' },
    { header: 'Tipo Movimentação', key: 'TIPO_MOVM', type: 'text' },
    { header: 'Data movimentação', key: 'DT_MOVM_PLTE', type: 'text' },
    { header: 'Placa da Carreta', key: 'TX_PLCA_CRRT', type: 'text' },
    { header: 'Motorista', key: 'NM_MTRT', type: 'text' },
    { header: 'Situação', key: 'FL_STTS', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.viewPalete(item)
        },
        {
          label: 'Download Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) =>
            this.downloadTicket(Number(item.PK_MOVM_PLTE), item.TIPO_MOVM)
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          action: (item: any) =>
            this.imprimirTicket(Number(item.PK_MOVM_PLTE), item.TIPO_MOVM)
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private paleteService: PaleteService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService
  ) {}

  private initForm() {
    const form = this.fb.group({
      FK_AGND: [null],
      FK_EPSA: [null],
      NM_MTRT: [null],
      TX_PLCA_CRRT: [null],
      DT_INIC: [null],
      DT_FIM: [null]
    });
    return form;
  }

  ngOnInit() {
    this.getPaletes();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getPaletes();
    });
  }

  getPaletes(): void {
    this.isLoading = true;
    const params = this.createParams();
    this.paleteService
      .GetMovimentacoesPaletesPaginatedByFilters(params)
      .subscribe({
        next: res => {
          const data = res.ITEMS;
          this.tableData = data.map(item => {
            let carretas: any[] = [];
            if (item.TX_PLCA_CRRT_1) carretas.push(item.TX_PLCA_CRRT_1);
            if (item.TX_PLCA_CRRT_2) carretas.push(item.TX_PLCA_CRRT_2);
            if (item.TX_PLCA_CRRT_3) carretas.push(item.TX_PLCA_CRRT_3);

            return {
              PK_MOVM_PLTE: item.PK_MOVM_PLTE,
              FK_AGND: item.FK_AGND,
              FK_MOVM_PLTE: item.FK_MOVM_PLTE ?? '---',
              TIPO_MOVM: item.FL_ENTR_PLTE ? 'Entrada' : 'Saída',
              DT_MOVM_PLTE: formatarData(item.DT_MOVM_PLTE),
              TX_PLCA_CRRT: carretas.join(' | '),
              FK_CRRT: item.FK_CRRT,
              NM_MTRT: item.NM_MTRT ?? '---',
              FL_ENTR_PLTE: item.FL_ENTR_PLTE,
              FL_STTS: item.FL_STTS,
              TX_OBSV_MOVM_PLTE: item.TX_OBSV_MOVM_PLTE,
              QT_MOVM_PLTE: item.QT_MOVM_PLTE,
              NU_ITEM_MOVM: item.NU_ITEM_MOVM,
              TX_PLCA_CAVA: item.TX_PLCA_CAVA
            };
          });
          this.isLoading = false;
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  createParams(): IGetMovimentacoesPaletesPaginatedByFiltersParams {
    return {
      FK_AGND: this.form.get('FK_AGND')?.value,
      FK_EPSA: this.form.get('FK_EPSA')?.value,
      NM_MTRT: this.form.get('NM_MTRT')?.value,
      TX_PLCA_CRRT: this.form.get('TX_PLCA_CRRT')?.value,
      DT_INIC: this.form.get('DT_INIC')?.value,
      DT_FIM: this.form.get('DT_FIM')?.value,
      PAGE_NUMBER: this.numeroPagina,
      PAGE_SIZE: 8
    };
  }

  viewPalete(item: any) {
    const queryParams = {
      ...item,
      isViewing: true
    };
    if (!item.FL_ENTR_PLTE) {
      this.router.navigate(['cadastro/saida-estacionamento-tpg'], {
        queryParams: queryParams
      });
      return;
    }
    this.router.navigate(['cadastro/entrada-estacionamento-tpg'], {
      queryParams: queryParams
    });
    return;
  }

  navigateNovaEntrada() {
    this.router.navigate(['cadastro/entrada-estacionamento-tpg']);
  }

  navigateNovaSaida() {
    this.router.navigate(['cadastro/saida-estacionamento-tpg']);
  }

  mudarPagina(pagina: number) {
    this.numeroPagina = pagina;
    this.getPaletes();
  }

  downloadTicket(id: number, tipoMovimentacao: string) {
    this.isLoading = true;

    if (tipoMovimentacao === 'Entrada') {
      this.paleteService
        .GetReceiptEntradaMovimentacaoPaleteById(id, 0)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
            this.isLoading = false;
          },
          error: _error => {
            this.isLoading = false;
          }
        });
      return;
    }
    if (tipoMovimentacao === 'Saída') {
      this.paleteService
        .GetReceiptSaidaMovimentacaoPaleteById(id, 0)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
            this.isLoading = false;
          },
          error: _error => {
            this.isLoading = false;
          }
        });
      return;
    }
  }

  imprimirTicket(id: number, tipoMovimentacao: string) {
    this.isLoading = true;

    if (tipoMovimentacao === 'Entrada') {
      this.paleteService
        .GetReceiptEntradaMovimentacaoPaleteById(id, 1)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.isLoading = false;
            this.impressoraService.impressoraTicket(
              response.ReportBase64,
              'text/plain'
            );
          },
          error: _error => {
            this.isLoading = false;
          }
        });
      return;
    }
    if (tipoMovimentacao === 'Saída') {
      this.paleteService
        .GetReceiptSaidaMovimentacaoPaleteById(id, 1)
        .subscribe({
          next: (response: IGetReportBase64) => {
            this.isLoading = false;
            this.impressoraService.impressoraTicket(
              response.ReportBase64,
              'text/plain'
            );
          },
          error: _error => {
            this.isLoading = false;
          }
        });
      return;
    }
  }
}
